<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fy2Kyk/tc-custom/9781504075633.jpg?1696633112351" alt="This image is the cover for the book Ulysses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ulysses
      </h1>
      <p class="bookDescription body article font2">
        <b>This iconic work of experimental modernism “comes nearer to being the perfect revelation of a personality than any book in existence” (<i>The New York Times</i>).</b><br/>  <br/> Taking place on June 16, 1904, <i>Ulysses</i> follows the itinerant journeys of Leopold Bloom and Stephen Dedalus as they make their way through an ordinary day in Dublin. With stream-of-conscious narration, Joyce weaves a sprawling yet incisive portrait of his characters, the nature of desire, and Dublin itself.<br/>  <br/> First published in Paris in 1922, Joyce’s masterwork was once banned for obscenity in the United States and Britain. Hailed as a work of genius by Ezra Pound, Ernest Hemingway, and many others, <i>Ulysses</i> remains one of the most significant works in English literature.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Joyce
      </h2>
      
      <p class="authorDescription body article">James Joyce (1882&ndash;1941) was an Irish poet, novelist, and short story author and one of the most innovative artists of the twentieth century. His best-known works include <I>Dubliners</I>,<I> A Portrait of the Artist</I><I>as a Young Man</I>,<I> Finnegans Wake</I>, and <I>Ulysses</I>, which is widely considered to be the greatest novel in the English language.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17efd298